export enum InsurancePriorityTypesEnum {
  Primary = 1,
  Secondary = 2,
  Tertiary = 3,
}
